import script from "./ErrorNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorNotification.vue?vue&type=script&setup=true&lang=js"

import "./ErrorNotification.vue?vue&type=style&index=0&id=eabb556c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eabb556c"]])

export default __exports__